(function () {
    'use strict';

    run.admin.parts.tileTypeFileUpload = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const rackoot_data = document.getElementById('rackoot_data');

        let fileTileDropzone = new Dropzone("#dashboard_canvas", {
            url: GlobalRoutes.tiles.types.file.upload,
            method: 'post',
            maxFilesize: 52428800, // 50 MB,
            // headers: {
            //     'CSRF-Name': csrf_name,
            //     'CSRF-Value': csrf_value,
            // }
        });

        fileTileDropzone.on('sending', function (file, xhr, formData) {
            formData.append('csrf_name', csrf_name);
            formData.append('csrf_value', csrf_value);
            formData.append('rackoot_uuid', rackoot_data.dataset.uuid);
        });

        fileTileDropzone.on("addedfile", file => {
            createFileTile(file.name);
            // console.log(`File added: ${file.name}`);
        });

        function createFileTile(name)
        {
            // const values = {
            //     csrf_name: csrf_name,
            //     csrf_value: csrf_value,
            //     tool_uuid: tool_uuid,
            //     rackoot_uuid: document.getElementById('btn_new_menu').dataset.rackootUuid,
            // }

            // Add placeholder
            let newToolItem = document.getElementById('uploaded_file_template').innerHTML;
            newToolItem = replaceAll(newToolItem, {
                '{name}': name,
                '{icon}': '',
                '{initials}': '',
                "{bg}": '#ffffff',
                "{color}": '#3372b9',
                "{url}": '#',
                "{description}": '',
                "{uuid}": 'adding_tool_placeholder',
            });
            let tools_container = document.getElementById('tool_group__active');
            // tools_container.insertAdjacentHTML('beforeend', newToolItem);
            const placeholders = tools_container.querySelectorAll('.tool__placeholder');
            placeholders[0].insertAdjacentHTML('beforebegin', newToolItem);


            // // Request new
            // axios.post(GlobalRoutes.tools.add, values)
            //     .then(function (response) {
            //         let newToolItem = document.getElementById('tool_template').innerHTML;
            //         newToolItem = replaceAll(newToolItem, {
            //             '{name}': response.data.tool.name,
            //             '{icon}': (response.data.tool.icon === null) ? '' : response.data.tool.icon,
            //             "{bg}": response.data.tool.background,
            //             "{color}": response.data.tool.color,
            //             "{url}": response.data.tool.url,
            //             "{description}": (response.data.tool.description === null) ? '' : response.data.tool.description,
            //             "{uuid}": response.data.tool.uuid,
            //         });

            //         // remove placeholder
            //         const placeholder = document.getElementById('adding_tool_placeholder');
            //         if (placeholder !== null) {
            //             document.getElementById('adding_tool_placeholder').remove();
            //         }

            //         // Add new
            //         let tools_container = document.getElementById('tool_group__active');
            //         // tools_container.insertAdjacentHTML('beforeend', newToolItem);
            //         const placeholders = tools_container.querySelectorAll('.tool__placeholder');
            //         placeholders[0].insertAdjacentHTML('beforebegin', newToolItem);

            //         setTimeout(() => {
            //             let newToolInserted = tools_container.getElementsByClassName('adding')[0];
            //             newToolInserted.classList.remove('adding');
            //         }, 300);
            //         saveSorted();

            //         if (edit_after == true) {
            //             // const lastInserted = Array.from(
            //             //     tools_container.querySelectorAll('.tool')
            //             //   ).pop();
            //             const lastInserted = document.getElementById(response.data.tool.uuid);
            //             editTool(lastInserted);
            //         }
            //     })
            //     .catch(function (error) {
            //         // remove placeholder
            //         const placeholder = document.getElementById('adding_tool_placeholder');
            //         if (placeholder !== null) {
            //             document.getElementById('adding_tool_placeholder').remove();
            //         }
            //         // document.getElementById('adding_tool_placeholder').remove();
            //         new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
            //     });
        }
    };
})();
